import { useState, useCallback } from "react";
import { apiService } from "../services/apiClient";
import { apiUrl } from "../services/apiUrl";

export const useSidebarMenu = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Fetch the sidebar menu (personas/reports tree) for the current user
  const fetchMenu = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await apiService.get(apiUrl.aipdGetMenu());
      return response.data?.data;
    } catch (err) {
      const errorMessage = err.response?.data?.message || err.message;
      setError(errorMessage);
      console.error("Error fetching sidebar menu:", errorMessage);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  // Fetch the current user's role/type
  const fetchUserRole = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await apiService.get(apiUrl.aipdUserListByEmail());
      return response.data;
    } catch (err) {
      const errorMessage = err.response?.data?.message || err.message;
      setError(errorMessage);
      console.error("Error fetching user role:", errorMessage);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  const clearError = useCallback(() => setError(null), []);

  return {
    loading,
    error,
    fetchMenu,
    fetchUserRole,
    clearError,
  };
};

export default useSidebarMenu;
